<template>
  <div class="container">
      <div class="container-top">
          	<a-input v-model="secrchData.name" style="margin-left: 10px;" allowClear class="a_input_self margin_self" placeholder="请输入姓名" @keyup.enter.native="query"/>
			<a-button type="primary" @click="query"> 查询 </a-button>

      </div>
      <div class="container-center"></div>
      <div class="conteiner-bottom"></div>
  </div>
</template>

<script>
export default {
    data() {
			return {
                secrchData: {
                    name: '',
                }

            }
        },
    methods: {
        query() {

        }
    }

}
</script>

<style lang="less" scoped>
.container {
    margin: 10px;
    .container-top {
        margin: 10px 0;
    }

}

</style>